import React from 'react';
import { testimonials } from '../data/pendingContent';
export function Testimonials() {
  if (testimonials.length === 0) return null;
  const hasIllustrations = testimonials.some(t => t.image && t.imageIsIllustration);
  return <section aria-labelledby="testimonials-title" className="bg-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-216" data-mp="3fycpzlihi3a9">
      <div className="max-w-6xl mx-auto" data-id="element-217" data-mp="3azt41l3w4rhw">
        <h2 id="testimonials-title" className="font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal" data-id="element-218" data-mp="36yzfcpimj8ny">
          Vos mots, vos créations
        </h2>

        <ul className="mt-10 columns-1 md:columns-2 lg:columns-3 gap-5" data-id="element-219" data-mp="31yl7b7h0vypx">
          {testimonials.map(t => <li key={t.id} className="mb-5 break-inside-avoid" data-id="element-220" data-mp="2x11tg8o8lnyi">
              <figure className="overflow-hidden rounded-2xl border border-ink/10 bg-white shadow-soft" data-id="element-221" data-mp="2s2i21sqvjjyr">
                {t.image && <img src={t.image} alt={t.imageAlt ?? ''} loading="lazy" decoding="async" className="block aspect-[4/5] w-full object-cover" data-id="element-222" data-mp="v85b00rzzj4d" />}
                <div className={t.image ? 'px-6 pb-6 pt-5' : 'p-6 sm:p-7'} data-id="element-223" data-mp="h5y6c818d10g">
                  <blockquote className={`leading-relaxed text-ink ${t.image ? 'text-base' : 'font-serif text-lg sm:text-xl'}`} data-id="element-224" data-mp="h8179n3x8ejy">
                    « {t.quote} »
                  </blockquote>
                  {t.name && <figcaption className="mt-4 text-sm" data-id="element-225" data-mp="79v8vfhbpqju">
                      <span className="font-semibold text-teal" data-id="element-226" data-mp="c7wo1pbmp5q1">{t.name}</span>
                      {t.context && <span className="text-ink/70" data-id="element-227" data-mp="zxh8ydrced1y"> · {t.context}</span>}
                    </figcaption>}
                </div>
              </figure>
            </li>)}
        </ul>

        {hasIllustrations}
      </div>
    </section>;
}